<template>
  <div class="clinics-result">
    <search-bar
      v-on:changeSearch="changeSearch"
      v-on:changeServiceDefaultName="changeServiceDefaultName"
      :selectedServiceDefaultName="cx_selectedServiceDefaultName"
      :zipCode="cx_zipCode"
      :coordinates="cx_coordinates"
      :headerLogo="cx_header_logo"
      v-bind:key="cx_header_logo"
      @noAddress="noAddressFound()"
    >
    </search-bar>
    
    <clinic-result-subheader v-if="!cx_notFound && !cx_loading && !cx_locationBlocked && !showUnavailablePage && !cx_noNearbyClinics" :selectedServiceDefaultName="cx_selectedServiceDefaultName" />
    
    <div v-if="!showUnavailablePage" class="container-fluid results-container">
      <div class="row" v-show="cx_loading || !!cx_selectedServiceDefaultName && !!cx_coordinates || cx_prerender ">
        <div class="col-12" v-show="cx_services.length > 0 || cx_loading">
          <clinic-result-header
            v-if="!cx_notFound && !cx_showNotFoundPage && !cx_locationBlocked"
            v-on:changeSearchSort="changeSearchSort"
            :selectedSort="cx_selectedSort"
            :ServiceDefaultName="cx_selectedServiceDefaultName"
            :locationInfo="cx_address"
            :loading="cx_loading"
            v-bind:key="cx_services.length"
          ></clinic-result-header>
        </div>
      </div>
      <div v-if="cx_loading && !cx_showNotFoundPage && !cx_locationBlocked && !cx_notFound && !cx_noNearbyClinics">
        <service-clinic-card-skeleton  v-for="n in 4" :key="n" ></service-clinic-card-skeleton>
      </div>

      <div v-else-if="!cx_loading || cx_showNotFoundPage || cx_locationBlocked || cx_notFound || cx_noNearbyClinics" v-infinite-scroll="getServices">
        <not-found locationBlocked v-if="cx_locationBlocked" />
        <not-found noAddress @changeSearch="activateMyLocation" v-else-if="cx_notFound" />
        <div class="row" v-infinite-scroll="getServices" v-else-if="cx_services.length > 0">
          <div class="col-12" v-for="service in cx_services" v-bind:key="service.id">
            <service-clinic-card
              :clinicAvailableHours="cx_times"
              :service="service"
              v-on:goToSchedule="openScheduleModal"
            ></service-clinic-card>
          </div>
          <div class="col-12 no-more-results text-center" v-if="cx_currentPage >= cx_totalPages">
            <span>Este é o final dos resultados...</span>
          </div>
          <div @click="scrollToTop()" class="col-12 go-to-top" v-if="cx_currentPage >= cx_totalPages">
            <span>
              Ir para o topo <img class="arrow-up" height="16" width="16" src="@/assets/icons/arrow-up.svg" />
            </span>
          </div>
        </div>
        <not-found noNearbyClinics v-else-if="cx_noNearbyClinics" />
      </div>

      <not-found notFoundPage v-if="cx_showNotFoundPage" />
    </div>

    <div v-if="showUnavailablePage" class="page-unavailable">
      <img src="@/assets/images/404image.png" alt="404_image" />
      <label>Página indisponível</label>
      <p>Pedimos desculpas, o site está temporariamente indisponível. Nossa equipe está trabalhando para resolver o problema o mais rápido possível. <br>Por favor, volte em breve!</p>
    </div>

    <side-modal
      v-if="cx_serviceModal && cx_serviceModal.modalOpened"
      :opened="cx_serviceModal.modalOpened"
      @close="closeModal($event)"
    >
      <service-appoint
        :cx_address="cx_serviceModal.selectedService.clinic.address.street"
        :dayHasHoursAvailable="cx_dayHasHoursAvailable"
        :clinicAvailableHours="cx_times"
        :service="cx_serviceModal.selectedService"
        :opened="cx_serviceModal.modalOpened"
        @close="closeModal($event)"
      ></service-appoint>
    </side-modal>
    <div>
      <b-modal
        id="confirm-my-location-modal"
        hide-footer
        hide-header
        no-close-on-esc
        no-close-on-backdrop
      >
        <div class="btn-close-confirm-my-location-modal">
          <b-icon-x class="btn-close-modal" @click="closeConfirmMyLocationModal(false)"> </b-icon-x>
        </div>
        <div class="d-block text-center">
          <h3 class="location-modal-title">Permitir localização?</h3>
          <span class="location-modal-body">
            A Clinicarx usa sua localização para encontrar os serviços de saúde mais próximos de
            você.
          </span>
        </div>
        <div class="text-center">
          <b-button
            class="btn-allow-access-my-location-modal"
            block
            @click="confirmMyLocation"
            data-backdrop="static"
            data-keyboard="false"
            >Permitir</b-button
          >
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import ClinicsResult from "@/views/ClinicsResult/ClinicsResult";
export default ClinicsResult;
</script>

<style lang="scss">
@import "ClinicsResult.scss";
</style>
